import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { buildContext } from './buildContext';
export const [useGuidaPromptContext, GuidaPromptContextProvider] = buildContext();
export const GuidaPromptProvider = ({ children, homePageLink }) => {
    const [isPromptVisible, setIsPromptVisible] = useState(false);
    const closePrompt = useCallback(() => {
        setIsPromptVisible(false);
    }, []);
    const openPrompt = useCallback(() => {
        setIsPromptVisible(true);
    }, []);
    return (_jsx(GuidaPromptContextProvider, { value: { isPromptVisible, closePrompt, openPrompt, homePageLink }, children: children }));
};
//# sourceMappingURL=promptContext.js.map